import React, { useCallback, useEffect, useRef, useState } from "react";
import { ErrorMessage } from "../../components/ErrorMessage";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { ListCommanWay, UpdateCommanWay } from "API/commonApi";
import { Link, useSearchParams } from "react-router-dom";
import { AfDataType } from "utils/TableColumnData";
import UseToast from "utils/AfToast";
import Spinner from "utils/Spinner";
import { AxiosResponse } from "axios";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { GlobeAltIcon, MapIcon, PhoneIcon } from "@heroicons/react/24/outline";

export type AfTableProps = Partial<{
  onColor: string;
  offColor: string;
  onHandleColor: string;
  offHandleColor: string;
  value: string | boolean;
  className: string;
  checkedIcon: React.ReactNode;
  uncheckedIcon: React.ReactNode;
  errors: any[];
  onChange: Function;
  handleCustom: Function;
  customBtnText?: string;
  customRenderFunction?: Function;

  columnData: any[];
  selectable: boolean;
  doAdd: boolean;
  doEdit: boolean;
  doDelete: boolean;
  doExport: boolean;
  paginate: boolean;
  routeUrl: string;
  apiUrl: string;
}>;

const DataTable: React.FC<AfTableProps> = ({
  onChange,

  onColor = "",
  offColor = "",
  onHandleColor = "",
  offHandleColor = "",
  value = false,
  className = "",
  checkedIcon = <></>,
  uncheckedIcon = <></>,
  errors = [],
  handleCustom = (id) => {},
  customRenderFunction = undefined,

  customBtnText = "",

  columnData = [],
  doAdd = true,
  doEdit = true,
  doDelete = true,
  doExport = true,
  paginate = true,
  routeUrl = "/",
  apiUrl = "/",
}) => {
  const [qParam, setQParam] = useSearchParams();

  const [isFirstLoad, setIsFirstLoad] = useState<any>(true);
  const [tableData, setTableData] = useState<any>([]);

  const [currentPage, serCurrentPage] = useState<number>(1);
  const [perPage, setPerPageCount] = useState<number>(25);
  const [pageCount, setPageCount] = useState<number>(1);
  const [itemCount, setItemCount] = useState<number>(1);

  const [filters, setFilters] = useState<any>(qParam.get("tp") ? { isThirdParty: Boolean(Number(qParam.get("tp")) || 0) } : {});
  const [isFilterChange, setIsFilterChange] = useState(false);

  const [showIdCardPopup, setShowIdCardPopup] = useState<any>({});
  const fileInputRef = useRef(null);
  const [imageSrc, setImageSrc] = useState("/images/icard-photo.jpg");

  //const [includes, setIncludes] = useState<any>([]);
  let incAry = [];
  columnData.forEach((c) => {
    if (c.db_col) {
      incAry.push("_" + c.key);
    }
  });
  console.log(incAry);
  //setIncludes(incAry);

  const { error, isFetching, isError, isFetched, isLoading, refetch } = useQuery(
    [apiUrl.replaceAll("/", "_")],
    () =>
      ListCommanWay(
        apiUrl,
        filters,
        apiUrl.indexOf("state") !== -1
          ? {}
          : {
              include: incAry,
              page: currentPage,
              paginate: 100,
            }
      ),
    {
      keepPreviousData: true,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          setIsFirstLoad(false);
          setTableData(data.data.data);
          serCurrentPage(data.data.paginator?.currentPage);
          setPerPageCount(data.data.paginator?.perPage);
          setPageCount(data.data.paginator?.pageCount);
          setItemCount(data.data.paginator?.itemCount);
        }
      },
    }
  );

  const performRefetch = useCallback(() => {
    setTableData([]);
    refetch();
  }, [refetch]);

  useEffect(() => {
    if (isFilterChange) {
      serCurrentPage(1); // Reset page only on filter change
      performRefetch();
      setIsFilterChange(false); // Reset flag after refetch
    } else {
      performRefetch();
    }
  }, [currentPage, isFilterChange, performRefetch]);

  useEffect(() => {
    if (!isFirstLoad) {
      setIsFilterChange(true);
    }
  }, [filters]);

  useEffect(() => {
    if (!isFirstLoad) {
      //performRefetch();
      let _oldFilter = { ...filters };
      _oldFilter.isThirdParty = Boolean(Number(qParam.get("tp")) || 0);
      setFilters(_oldFilter);
    }
  }, [qParam.get("tp")]);

  const {
    mutate: updateBookingMutate,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation((data) => UpdateCommanWay(data), {
    onSuccess: (data: any) => {
      console.log(data, data.status == "SUCCESS");
      if (data.status == "SUCCESS") {
        UseToast("Data Updated Successfully", "success");
        window.location.reload();
        //navigate("/report/booking");
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
    },
  });

  const { mutate: mutateApproveDeviceId } = useMutation(
    (data) => ListCommanWay("/admin/mac-id/approve", { id: data, apiUrl: apiUrl }, {}),
    {
      onSuccess: (data: any) => {
        console.log(data, data.status == "SUCCESS");
        if (data.status == "SUCCESS") {
          UseToast("Approval Successfully", "success");
          window.location.reload();
        } else {
          UseToast(data.message, "error");
        }
      },
      onError: (data: any) => {
        typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      },
    }
  );

  const { mutate: mutateApprovePcDeviceId } = useMutation(
    (data) => ListCommanWay("/admin/pc-mac-id/approve", { id: data, apiUrl: apiUrl }, {}),
    {
      onSuccess: (data: any) => {
        console.log(data, data.status == "SUCCESS");
        if (data.status == "SUCCESS") {
          UseToast("Approval Successfully", "success");
          window.location.reload();
        } else {
          UseToast(data.message, "error");
        }
      },
      onError: (data: any) => {
        typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      },
    }
  );

  const handleImageClick = () => {
    fileInputRef.current.click(); // Trigger file picker
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageSrc(reader.result as string); // Update preview
      };
      reader.readAsDataURL(file);
    } else {
      alert("Please select a valid image file.");
    }
  };

  const icMul = 1.5;
  const cardWw = 53.98 * icMul;
  const downloadIdCardPopup = async () => {
    document.body.classList.add("inline-all-img");
    try {
      const input1 = document.getElementById("pdf-content1");
      const input2 = document.getElementById("pdf-content2");
      const canvas = await html2canvas(input1);
      const canvas2 = await html2canvas(input2);
      const imgData = canvas.toDataURL("image/png");
      const imgData2 = canvas2.toDataURL("image/png");

      document.body.classList.remove("inline-all-img");

      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: [85.6 * icMul, 53.98 * icMul],
      });
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.addPage();
      pdf.addImage(imgData2, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("download.pdf");
    } catch {
      document.body.classList.remove("inline-all-img");
    }
  };

  return (
    <div className="p-5">
      {isLoading && <Spinner />}

      {showIdCardPopup?.id && (
        <div
          className="hidden- flex flex-col fixed left-0 right-0 top-0 h-[100vh] items-center justify-center gap-2"
          style={{ zIndex: 1001 }}
        >
          <div
            className="bg-black-900/50 absolute w-full h-full"
            onClick={() => {
              setShowIdCardPopup({});
            }}
          ></div>
          <div className="flex gap-2">
            <div
              id="pdf-content1"
              className="bg-white relative overflow-hidden html2canvas-container"
              style={{
                width: cardWw + "mm",
                height: 85.6 * icMul + "mm",
              }}
            >
              <img src="/images/icard-top.jpg" className="w-full inline-block" />

              <div className="text-center">
                <img
                  src={imageSrc}
                  alt="ID Card"
                  className="relative z-10 mx-auto inline-block"
                  onClick={handleImageClick}
                  style={{ height: 27 * icMul + "mm", marginTop: 3 * icMul + "mm" }}
                />
                <input type="file" accept="image/*" ref={fileInputRef} style={{ display: "none" }} onChange={handleFileChange} />
              </div>

              <div className="text-center relative z-20">
                <h1
                  style={{
                    fontSize: 6 * icMul + "mm",
                    lineHeight: 7 * icMul + "mm",
                  }}
                  className="font-oswald font-semibold text-[#0c4ea0]"
                >
                  {showIdCardPopup.name}
                </h1>
                <div
                  className="w-full h-[2px] rounded-[100%]"
                  style={{
                    backgroundImage: "radial-gradient(circle at center, #0c4ea0, rgb(255,255,255))",
                  }}
                ></div>
                <h2 style={{ fontSize: 2.5 * icMul + "mm" }} className="font-montserrat font-semibold" contentEditable>
                  Field Operation
                </h2>
              </div>

              <div
                className="bg-gray-300/70 relative z-10"
                style={{
                  margin: 1 * icMul + "mm " + 2.5 * icMul + "mm",
                  padding: 2 * icMul + "mm",
                  borderRadius: 1.5 * icMul + "mm",
                }}
              >
                <table className=" font-semibold" style={{ fontSize: 2 * icMul + "mm" }}>
                  <tbody>
                    <tr className="border-b-2 border-gray-400">
                      <td>Expiry Date</td>
                      <td contentEditable>2026, Feb</td>
                    </tr>
                    <tr className="border-b-2 border-gray-400">
                      <td>Date Of Birth</td>
                      <td contentEditable>11/11/2025</td>
                    </tr>
                    <tr className="">
                      <td>Blood Group</td>
                      <td contentEditable>ABCD+-</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div
                className="bg-white relative z-10 flex items-center justify-between"
                style={{
                  margin: 1.5 * icMul + "mm " + 2.5 * icMul + "mm",
                  borderRadius: 1.5 * icMul + "mm",
                  padding: 1 * icMul + "mm " + 2 * icMul + "mm",
                }}
              >
                <span>Signature Authority</span>
                <img src="/images/ic-sign.png" style={{ height: 6 * icMul + "mm" }} />
              </div>

              <img
                src="/images/world.png"
                style={{ minWidth: cardWw * 1.1 + "mm" }}
                className={`absolute top-[20%] -left-[5%] opacity-20`}
              />
              <img
                src="/images/icard-bg.png"
                style={{ minWidth: cardWw * 1.2 + "mm" }}
                className={`absolute -bottom-[18%] -left-[8%] rotate-45`}
              />
            </div>
            <div
              id="pdf-content2"
              className="bg-white relative overflow-hidden"
              style={{ width: cardWw + "mm", height: 85.6 * icMul + "mm" }}
            >
              <div
                className="text-center relative z-20 bg-[#0c4ea0]"
                style={{
                  padding: 1.5 * icMul + "mm " + 2 * icMul + "mm",
                  marginTop: 7 * icMul + "mm",
                }}
              >
                <h1 style={{ fontSize: 4 * icMul + "mm", lineHeight: 1.3 }} className="font-inter text-white">
                  THE IDENTITY CARD IS
                </h1>
              </div>

              <div className="relative z-10">
                <ol
                  className="list-decimal"
                  style={{
                    fontSize: 2.5 * icMul + "mm",
                    margin: `${1 * icMul}mm ${2 * icMul}mm ${1 * icMul}mm ${5 * icMul}mm`,
                  }}
                >
                  <li>Issued as per the terms & condition of employment of contract with Airfield Express Pvt Ltd.</li>
                  <li>The property of Airfield Express Pvt Ltd and must be surrendered on request of cessation of employment.</li>
                  <li>Misuse of the identity card may lead to termination of employment.</li>
                  <li>Not valid to enter government secured area.</li>
                </ol>
              </div>

              <div
                className="w-full h-[2px] rounded-[100%]"
                style={{
                  backgroundImage: "radial-gradient(circle at center, #0c4ea0, rgb(255,255,255))",
                }}
              ></div>

              <div
                className="bg-white relative z-10 flex items-center justify-between"
                style={{
                  margin: 1.5 * icMul + "mm " + 2.5 * icMul + "mm",
                  borderRadius: 1.5 * icMul + "mm",
                  padding: 1 * icMul + "mm " + 2 * icMul + "mm",
                }}
              >
                <span>Signature Authority</span>
                <img src="/images/ic-sign.png" style={{ height: 6 * icMul + "mm" }} />
              </div>

              <div
                className="bg-[#0c4ea0]/80 relative z-10  text-white flex flex-col"
                style={{
                  margin: 1.5 * icMul + "mm " + 2.5 * icMul + "mm",
                  borderRadius: 1.5 * icMul + "mm",
                  padding: 1 * icMul + "mm " + 2 * icMul + "mm",
                  gap: `${0.8 * icMul}mm`,
                }}
              >
                <div
                  className="flex"
                  style={{
                    fontSize: `${2.2 * icMul}mm`,
                  }}
                >
                  <MapIcon
                    style={{
                      height: `${3.5 * icMul}mm`,
                      minWidth: `${3.5 * icMul}mm`,
                      marginRight: `${1 * icMul}mm`,
                    }}
                  />
                  <span>UL 1, Empire tower, Nr. Associated petrol pump, C.G road, Ahmedabad, 380006</span>
                </div>
                <div
                  className="flex items-center"
                  style={{
                    fontSize: `${2.2 * icMul}mm`,
                  }}
                >
                  <PhoneIcon
                    style={{
                      height: `${3.5 * icMul}mm`,
                      minWidth: `${3.5 * icMul}mm`,
                      marginRight: `${1 * icMul}mm`,
                    }}
                  />
                  <span>9227223131</span>
                </div>
                <div
                  className="flex items-center"
                  style={{
                    fontSize: `${2.2 * icMul}mm`,
                  }}
                >
                  <GlobeAltIcon
                    style={{
                      height: `${3.5 * icMul}mm`,
                      minWidth: `${3.5 * icMul}mm`,
                      marginRight: `${1 * icMul}mm`,
                    }}
                  />
                  <span>www.airfield.co.in</span>
                </div>
              </div>

              <img
                src="/images/world.png"
                style={{ minWidth: cardWw * 1.1 + "mm" }}
                className={`absolute top-[20%] -left-[5%] opacity-15`}
              />
              <img
                src="/images/icard-bg.png"
                style={{ minWidth: cardWw * 1.2 + "mm" }}
                className={`absolute -bottom-[18%] -left-[8%] rotate-45`}
              />
            </div>
          </div>
          <div className="mt-2 relative x-10">
            <button onClick={downloadIdCardPopup} className="bg-primary text-white px-4 py-2 rounded-md">
              Download
            </button>
          </div>
        </div>
      )}

      <div className="inline-flex rounded-md overflow-hidden shadow-sm mb-1" role="group">
        <Link
          to={routeUrl + "/add"}
          type="button"
          className="px-4 py-2 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
        >
          Add
        </Link>
        {/*<button
          type="button"
          className="px-4 py-2 text-sm font-medium text-white bg-yellow-500 border-t border-b border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
        >
          Edit
        </button>
        <button
          type="button"
          className="px-4 py-2 text-sm font-medium text-white bg-red-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
        >
          Delete
        </button>

        <button
          type="button"
          className="px-4 py-2 text-sm font-medium text-white bg-dark1 border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
        >
          Download Excel
        </button>*/}
      </div>
      <div className="flex overflow-auto">
        <table className="w-full text-sm text-left text-gray-500 border-r border-t">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
            <tr>
              {columnData.map((c) => {
                return (
                  c.view && (
                    <th scope="col" className="px-6 py-3 border-l border-b" key={c.label}>
                      <div className="flex items-center">
                        {c.label}
                        {c.sort && false && (
                          <a href="#">
                            <svg
                              className="w-3 h-3 ml-1.5"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                            </svg>
                          </a>
                        )}
                      </div>
                      {c.filter == 11 && (
                        <>
                          <input
                            type="search"
                            className="block p-1 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 "
                            placeholder="Search"
                            onKeyDown={(event: any) => {
                              if (event.key === "Enter") {
                                let _filters = { ...filters };
                                let val = event.target?.value;
                                if (!val) {
                                  delete _filters[c.key];
                                } else {
                                  if (c.type == AfDataType.TEXT) {
                                    _filters[c.key] = { $like: `%${val}%` };
                                  }
                                  if (c.type == AfDataType.SELECT) {
                                    _filters[c.key] = { $like: `%${val}%` };
                                  }
                                }
                                setFilters(_filters);
                              }
                            }}
                          />
                        </>
                      )}
                    </th>
                  )
                );
              })}
            </tr>
          </thead>

          <tbody>
            {tableData.map((rd, j) => {
              return (
                <tr className={`${rd.isActive ? "bg-white" : "bg-red-500 text-white"}  border-b`} key={"tbl-tr-" + j}>
                  {columnData.map((cd, i) => {
                    return (
                      cd.view && (
                        <td className="border-l px-2 py-1" key={"tbl-td-" + i}>
                          {cd.type == AfDataType.CUSTOM ? (
                            customRenderFunction !== undefined ? (
                              customRenderFunction(rd)
                            ) : (
                              <button className="text-dark1" onClick={() => handleCustom(rd)}>
                                {customBtnText}
                              </button>
                            )
                          ) : cd.type == AfDataType.VIEW ? (
                            cd.key == "i_card" ? (
                              <>
                                <button className="text-dark1" onClick={() => setShowIdCardPopup(rd)}>
                                  ID-Card
                                </button>
                              </>
                            ) : cd.key == "macId" ? (
                              <>
                                <button className="text-dark1" onClick={() => mutateApproveDeviceId(rd.id)}>
                                  Approve
                                </button>
                              </>
                            ) : cd.key == "pcMacId" ? (
                              <>
                                <button className="text-dark1" onClick={() => mutateApprovePcDeviceId(rd.id)}>
                                  Approve
                                </button>
                              </>
                            ) : (
                              <Link className="text-dark1" to={`${routeUrl}/list/${rd[cd.key]}`}>
                                View
                              </Link>
                            )
                          ) : cd.type == AfDataType.DB ? (
                            <>{rd["_" + cd.key] ? rd["_" + cd.key][cd.db_col] : "-"}</>
                          ) : cd.type == AfDataType.BOOLEAN ? (
                            <>
                              {rd[cd.key] === true ? "Yes" : "No"}
                              {cd.changeBtn ? (
                                <>
                                  <button
                                    className="ml-2 text-dark1"
                                    onClick={() => {
                                      let dataC = {};
                                      dataC[cd.key] = !rd[cd.key];
                                      updateBookingMutate({
                                        url: apiUrl.replaceAll("/list", "/update/") + rd.id,
                                        data: dataC,
                                      });
                                    }}
                                  >
                                    Change
                                  </button>
                                </>
                              ) : (
                                ""
                              )}
                            </>
                          ) : cd.render ? (
                            cd.render(rd[cd.key], rd)
                          ) : (
                            <>{rd[cd.key]}</>
                          )}
                        </td>
                      )
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <nav className="flex items-center justify-between pt-4" aria-label="Table navigation">
        <span className="text-sm font-normal text-gray-500">
          Total: <span className="font-semibold text-gray-900">{itemCount}</span>
        </span>
        <ul className="inline-flex -space-x-px text-sm h-8">
          <li>
            <div
              onClick={() => serCurrentPage((prevData) => (prevData > 1 ? prevData - 1 : prevData))}
              className="flex items-center justify-center px-3 h-8 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 hover:text-gray-700 "
            >
              Previous
            </div>
          </li>
          {Array.from({ length: pageCount }, (_, i) => i + 1).map((p) => (
            <li key={"paginate-" + p}>
              <button
                onClick={() => serCurrentPage(p)}
                type="button"
                aria-current={currentPage === p ? "page" : undefined}
                className={`flex items-center justify-center px-3 h-8 border border-gray-300
                  ${
                    currentPage === p
                      ? "text-blue-600 bg-blue-50 hover:bg-blue-100 hover:text-blue-700"
                      : "text-gray-500 bg-white hover:bg-gray-100 hover:text-gray-700"
                  }`}
              >
                {p}
              </button>
            </li>
          ))}
          <li>
            <div
              // href="#"
              onClick={() => serCurrentPage((prevData) => (prevData < pageCount ? prevData + 1 : prevData))}
              className="flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-gray-100 hover:text-gray-700 "
            >
              Next
            </div>
          </li>
        </ul>
      </nav>
      <ErrorMessage errors={errors} />
    </div>
  );
};

export { DataTable };
